import apiClientCreator from "../../helpers/api/request";
import SocketEndpoints from "../../mixins/system/SocketEndpoints";
import store from "../../store";

// export async function loginAttempt({ commit, state }, credentials) {
//   try {
//     let apiClient = apiClientCreator("auth/login");
//     let response = await apiClient.post("", {
//       // email: credentials.email,
//       password: credentials.username_special,
//       username_special: credentials.username_special
//     });
//
//     localStorage.setItem("user-token", response.data.token);
//     // localStorage.setItem("user-token-login-time", moment());
//     commit(
//       "clients/onAuthSuccess",
//       { token: response.data.token },
//       { root: true }
//     );
//   } catch (e) {
//     localStorage.removeItem("user-token");
//     commit("setBadAttemptToLogIn", true);
//     commit("setErrorInfo", "Log-In Failed");
//   }
// }


// eslint-disable-next-line no-unused-vars
// export async function getProfile({ commit, state }) {
//   try {
//     let apiClient = apiClientCreator("auth/me");
//     let response = await apiClient.get();
//     commit("clients/setProfileData", response.data, { root: true });
//     // const data = this.auth.user.id;
//     SocketEndpoints.loginMsgSocket.connect();
//     //SocketEndpoints.loginMsgSocket.emit("send_id", response.data.id);
//   } catch (e) {
//     //   localStorage.removeItem("user-token");
//   }
// }

// eslint-disable-next-line no-unused-vars
// export function logOut({ commit, state }) {
//   return new Promise((resolve, reject) => {
//     let apiClient = apiClientCreator("auth/logout");
//
//     apiClient
//       .post("", { user_id: store.getters["clients/getUserId"] })
//       // eslint-disable-next-line no-unused-vars
//       .then(response => {
//         commit("clients/onLogout", null, { root: true });
//         localStorage.removeItem("user-token");
//         SocketEndpoints.loginMsgSocket.disconnect();
//         resolve();
//       })
//       .catch(err => {
//         localStorage.removeItem("user-token");
//         reject(err);
//       });
//   });
// }

// export async function getSystemDictionary({ commit, state }) {
//   try {
//     let apiClient = apiClientCreator("system/dictionary");
//     let response = await apiClient.get();
//     commit("clients/setSystemDictionary", response.data, { root: true });
//     return response;
//   } catch (e) {}
// }






// eslint-disable-next-line no-unused-vars
export async function getGeneralDictionary({ commit, state }) {
  try {
    let apiClient = apiClientCreator("client/dictionary");
    let response = await apiClient.get();
    commit("clients/setGeneralDictionary", response.data, { root: true });
    return response;
  } catch (e) {}
}



// eslint-disable-next-line no-unused-vars
export async function getActivityDictionary({ commit, state }) {
  try {
    let apiClient = apiClientCreator("client/activity-dictionary");
    let response = await apiClient.get();
    commit("clients/setActivityDictionary", response.data, { root: true });
    return response;
  } catch (e) {}
}

// eslint-disable-next-line no-unused-vars
export async function getSalesPersonList({ commit, state }) {
  try {
    let apiClient = apiClientCreator("sales-person");
    let response = await apiClient.get();
    commit("clients/setSalesPersonList", response.data, { root: true });
    return response;
  } catch (e) {}
}

export async function setAssigmentChoseName({ commit, state }, name) {
  commit("setAssigmentChoseName", name);
}
export async function setAssigmentChoseActive({ commit, state }, user) {
  commit("setAssigmentChoseActive", user);
}
export async function setAssigmentChoseAll({ commit, state }, user) {
  commit("setAssigmentChoseAll", user);
}
export async function setAssigmentShowCart(
  { commit, state },
  assignReportsForDay
) {
  commit("setAssigmentShowCart", assignReportsForDay);
}
export async function SetAssignReportsForMonth(
  { commit, state },
  assignReportsForMonth
) {
  commit("SetAssignReportsForMonth", assignReportsForMonth);
}

export async function dynamicTitleInfo({ commit, state }) {
  try {
    await apiClientCreator("client/stats/titleInfo")
      .get("", {})
      .then(res => {
        commit("SetTitleInfo", res.data);
      });
  } catch (e) {}
}
export async function setMultiSelect({ commit, state }, multiSelectData) {
  commit("multiSelectVsData", multiSelectData);
}

export async function setChartsViewBlocks({ commit, state }, blocks) {
  commit("chartsViewBlocks", blocks);
}

export async function setMultiselectCalendarType({ commit, state }, alias) {
  commit("multiselectCalendarType", alias);
}

let sT;
export async function startTheTimer({ commit, state }, opt) {
  if (opt) {
    clearTimeout(sT);
  } else {
    await new Promise(resolve => {
      sT = setTimeout(() => {
        commit("setTimerOn", "10");
        resolve("h");
      }, 60000);
    });
  }
}

export async function setDpChartData({ commit, state }, data) {
  let tab = data.tab;

  if (tab === "usersTab") {
    commit("setDpChartUsersData", data.data);
  }

  if (tab === "brokersTab") {
    commit("setDpChartBrokersData", data.data);
  }

  if (tab === "statusTab") {
    commit("setDpChartStatusesData", data.data);
  }

  if (tab === "quantityTab") {
    commit("setDpChartQuantityData", data.data);
  }

  if (tab === "secVoiceTab") {
    commit("setDpChartSecVoiceData", data.data);
  }

  if (tab === "brokerUsersTab") {
    commit("setDpBrokerUsersTabData", data.data);
  }

  if (tab === "leadingTab") {
    commit("setLeadingTabData", data.data);
  }
}
